export enum DocumentSignedStatusEnum {
	WAITING_SEND_EMAIL = 'WAITING_SEND_EMAIL',
	NOT_SIGNED = 'NOT_SIGNED',
	SIGNED = 'SIGNED',
}
